import { render, staticRenderFns } from "./esPrivacy.vue?vue&type=template&id=4d53aeb8&scoped=true&"
import script from "./esPrivacy.vue?vue&type=script&lang=js&"
export * from "./esPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./esPrivacy.vue?vue&type=style&index=0&id=4d53aeb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53aeb8",
  null
  
)

export default component.exports